import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { claves, useClienteApi } from "@/shared/api";

export function useInstituciones() {
  const api = useClienteApi();
  return useQuery({ queryKey: claves.instituciones, queryFn: () => api.instituciones(), staleTime: 60_000 });
}

export function useGuardarInstitucion() {
  const api = useClienteApi();
  const cache = useQueryClient();
  return useMutation({
    mutationFn: (x: { codigo: string; nombre: string; habilitada: boolean }) =>
      api.guardarInstitucion(x.codigo, x.nombre, x.habilitada),
    onSuccess: () =>
      Promise.all([
        cache.invalidateQueries({ queryKey: claves.instituciones }),
        cache.invalidateQueries({ queryKey: claves.auditoria }),
      ]),
  });
}
